// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStkstatacbeth } from "../../../icons/full/build/icon-stkstatacbeth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StkstatacbethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStkstatacbeth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StkstatacbethIcon.displayName = 'StkstatacbethIcon';
}

export default StkstatacbethIcon;